import { useTranslation } from "react-i18next";
import { useWindowSize } from "@uidotdev/usehooks";
// import { useState } from "react";
import {
  LeafButton,
  PoppyButton,
  PremiseButton,
} from "../../components/button";
import { Button, Slider } from "@mui/material";
import { useState } from "react";
import { Check1 } from "../../assets/svg/Check1";
import { useNavigate, Link } from "react-router-dom";

const license = [
  {
    name: "pricing.adminApplication",
    desc: "pricing.singleDeviceInstallation",
    cost: 95,
    buttonText: "pricing.requestALicense",
    detail: "pricing.theCheckidBioSenseAdminAppSimplifiesEmployee",
    listConvinient: [
      [
        "pricing.supportFaceFingerprintIris",
        "pricing.automaticFaceDetectionAndCapture",
        "pricing.faceLivenessDetection",
        "pricing.recognizeAllPersonsFromGroupPhoto",
        "pricing.geoFenceTracking",
      ],
      [
        "pricing.gpsLocationLogging",
        "pricing.offlineAttendanceLoging",
        "pricing.standlonePperation",
        "pricing.accessControl",
        "pricing.kioskMode",
        "pricing.rfidBarcode",
      ],
    ],
  },
  {
    name: "pricing.attendApplication",
    desc: "pricing.unlimitedInstallation",
    cost: "pricing.free",
    buttonText: "pricing.downloadApp",
    detail: "pricing.theCheckidBioSenseAppIsaFreeOInlineTool",
    listConvinient: [
      [
        "pricing.supportsFace",
        "pricing.geoFenceTracking",
        "pricing.gpsLocationLogging",
        "pricing.onlineAttendanceLogging",
      ],
    ],
  },
];
export const Pricing = () => {
  const { t, i18n } = useTranslation();
  const { width } = useWindowSize();
  const [slider, setSlider] = useState(50);
  const navigate = useNavigate();

  const pakages = [
    {
      name: "pricing.freePLan",
      trialTime: "pricing.price",
      cost: 0,
      desc: "pricing.employee1",
      buttonText: "pricing.sign",
      note: (
        <p>
          <span className="text-[#4B2BE3] uppercase">{t("pricing.note")}</span>:
          {/* Free plan users have the opportunity to upgrade their subscription to  */}{" "}
          {t("pricing.freePlan")} &quot;
          <strong>
            {/* Free for life */}
            {t("pricing.freeForLife")}
          </strong>
          &ldquo;{" "}
          {/* by sharing their system experience
        through the system dashboard. */}
          {t("pricing.byShareTheirSystemExperience")}
        </p>
      ),
      listConvinient: [
        "pricing.premises",
        "pricing.face",
        "pricing.gpsTracking",
        "pricing.faceMaskDetection",
        "pricing.timesheetAndReport",
        "pricing.personalDevicePerEmployee",
        "pricing.devidePerEmployeeGroup",
        "pricing.workShedule",
        "pricing.videoTracking",
      ],
    },
    {
      name: "pricing.free1",
      trialTime: "pricing.price1",
      cost: 1.5,
      desc: "pricing.employee2",
      buttonText: "pricing.getstart",
      note: t("pricing.everythingInPlanFree"),
      listConvinient: [
        "pricing.faceAndFinger",
        "pricing.rfidBarcode",
        "pricing.gpsTracking",
        "pricing.ipCamera",
        "pricing.breakHours",
        "pricing.locationRestriction",
        "pricing.videoTracking",
        "pricing.registrationInformationKiosk",
        "pricing.accessControl",
        "pricing.reportsCustomization",
        "pricing.ultimatePersonalDevices",
        "pricing.unlimitedDevicePergroup",
        "pricing.customReportCalculation",
        "pricing.importExportData",
      ],
    },
    {
      name: "pricing.free3",
      trialTime: "pricing.price3",
      cost: 3,
      desc: "pricing.employee3",
      buttonText: "pricing.getstart",
      note: t("pricing.everythingInPlanFree"),
      listConvinient: [
        "pricing.faceFigerprintIris",
        "pricing.safetyHatDetection",
        "pricing.rfidBarCodeLicensePlate",
        "pricing.visitorQueue",
        "pricing.visitorNote",
        "pricing.upTo3000Visits",
        "pricing.badgeReceiptPrinting",
        "pricing.accessControl",
        "pricing.notifications",
        "pricing.customFeatureExtensions",
        "pricing.biometicDeuplication",
      ],
    },
  ];
  return (
    <>
      {/* Header */}
      <div
        className=" bg-cover bg-center h-[360px] md:h-[250px] smAndmd:h-[180px] exact1024:h-[200px]"
        style={{
          backgroundImage:
            "url('/src/assets/img/industries/biometricoffice/group.png')",
        }}
      >
        <div className="md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] mx-auto pl-[10px] exact1024:pt-[20px] exact1024:pb-[20px] smAndmd:pt-[20px] smAndmd:pb-[20px] pt-[68px] minxl:pt-[100px]">
          <h1
            className={`inline-block border-b-[10px] h-[51px] text-5xl text-white font-extrabold leading-[60px] border-[#B9AAFD]`}
          >
            {t("pricing.header")}
          </h1>
        </div>
      </div>

      <div className="md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] smAndmd:pt-0 exact1024:pt-0 pt-[50px] pb-[74px] mx-auto px-[10px]">
        <div className=" flex justify-center gap-[35px] pt-[50px] items-center max-w-[1300px] max429:flex-col">
          <Slider
            value={slider}
            aria-label="Default"
            valueLabelDisplay="auto"
            onChange={(e) => setSlider(e.target.value)}
            min={1}
            max={1000}
            sx={{
              color: "#4B2BE3",
              display: "flex",
              gap: "5px",
              maxWidth: "400px",
              height: "8px",
              "& .MuiSlider-thumb": {
                backgroundColor: "white",
              },
            }}
          />
          <div>
            <p className="text-[#2B1C50] text-lg text-center mb-1.5">
              {/* Employee  (s)*/}
              {t("pricing.employee")}
            </p>
            <div className="flex items-center">
              <button
                className="w-8 h-8 p-2 text-white leading-4 bg-[#4B2BE3] rounded-lg "
                onClick={() => slider > 0 && setSlider((prev) => prev - 1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M14.5 8C14.5 8.13261 14.4473 8.25979 14.3536 8.35355C14.2598 8.44732 14.1326 8.5 14 8.5H3C2.86739 8.5 2.74021 8.44732 2.64645 8.35355C2.55268 8.25979 2.5 8.13261 2.5 8C2.5 7.86739 2.55268 7.74021 2.64645 7.64645C2.74021 7.55268 2.86739 7.5 3 7.5H14C14.1326 7.5 14.2598 7.55268 14.3536 7.64645C14.4473 7.74021 14.5 7.86739 14.5 8Z"
                    fill="#FCFCFC"
                  />
                </svg>
              </button>
              <input
                className=" rounded-lg mr-2 ml-2 border h-10 w-15 text-center flex items-center justify-center"
                type="number"
                value={slider}
                onChange={(e) =>
                  Number(e.target.value) > 0 &&
                  Number(e.target.value) <= 1000 &&
                  setSlider(e.target.value)
                }
                style={{
                  MozAppearance: "textfield",
                }}
              />
              <button
                className="w-8 h-8 p-2 text-white leading-4 bg-[#4B2BE3] rounded-lg"
                onClick={() => slider < 989 && setSlider((prev) => prev + 1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M14.5 8C14.5 8.13261 14.4473 8.25979 14.3536 8.35355C14.2598 8.44732 14.1326 8.5 14 8.5H9V13.5C9 13.6326 8.94732 13.7598 8.85355 13.8536C8.75979 13.9473 8.63261 14 8.5 14C8.36739 14 8.24021 13.9473 8.14645 13.8536C8.05268 13.7598 8 13.6326 8 13.5V8.5H3C2.86739 8.5 2.74021 8.44732 2.64645 8.35355C2.55268 8.25979 2.5 8.13261 2.5 8C2.5 7.86739 2.55268 7.74021 2.64645 7.64645C2.74021 7.55268 2.86739 7.5 3 7.5H8V2.5C8 2.36739 8.05268 2.24021 8.14645 2.14645C8.24021 2.05268 8.36739 2 8.5 2C8.63261 2 8.75979 2.05268 8.85355 2.14645C8.94732 2.24021 9 2.36739 9 2.5V7.5H14C14.1326 7.5 14.2598 7.55268 14.3536 7.64645C14.4473 7.74021 14.5 7.86739 14.5 8Z"
                    fill="#FCFCFC"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        {/* Packages Plan */}
        <div
          className={`flex items-center justify-center  pt-[50px] gap-8 flex-wrap`}
        >
          {pakages.map((e, index) => {
            const translatedName = t(e.name)?.trim().toLowerCase();
            const isFreePlan =
              translatedName.includes("free plan") ||
              translatedName.includes("gói miễn phí");

            return (
              <div
                className="flex flex-col w-[260px] items-center gap-[30px] self-stretch"
                key={index}
              >
                <div
                  className="flex flex-col items-center w-full h-[444px] self-stretch py-15 
        px-5 rounded-[20px] border-2 border-[#EFF0FF] bg-[#EFF0FF]"
                >
                  <p className="text-[#2B1C50] text-center text-[30px] font-extrabold mb-2">
                    {t(e.name)}
                  </p>
                  <p className="text-[#2B1C50] text-center text-[18px] font-montserrat">
                    {t(e.trialTime)}
                  </p>
                  <div className="flex flex-col items-center py-7.5">
                    <div className="flex gap-[20px] items-end">
                      <p className="text-[#151686] text-center text-[46px] max-w-54 font-extrabold break-words leading-tight">
                        <span className="text-[#002B4E]">$</span>{" "}
                        {e.cost * slider}
                      </p>
                    </div>
                    <p className="text-[#AEAEAE] text-center text-[22px] font-bold">
                      {t("pricing.month")}
                    </p>
                  </div>
                  <div className="flex items-center pb-[30px]">
                    <p className="text-[#2B1C50] text-center text-[18px] font-normal">
                      {t(e.desc)}
                    </p>
                  </div>
                  <div className="flex items-center xl:justify-center sm:flex-col gap-[16.7px]">
                    {isFreePlan ? (
                      <a
                        href="https://prd-facialsense.mobile-id.vn/signup"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <PoppyButton
                          onClick={() => navigate("/sign-up")}
                          style={{
                            borderColor: "var(--tree-poppy)",
                            color: "#F7941D",
                            height: "44px",
                          }}
                          title={t(e.buttonText)}
                        />
                      </a>
                    ) : (
                      <LeafButton
                        title={t(e.buttonText)}
                        style={{
                          backgroundColor: "var(--Primary, #151686)",
                          color: "#fff",
                          borderRadius: "45px",
                          whiteSpace:
                            i18n.language === "vi" ? "wrap" : "nowrap",
                          height: "44px",
                        }}
                      />
                    )}
                  </div>
                  <div className="flex flex-col items-center self-stretch xl:justify-center sm:flex-col gap-[30px]"></div>
                </div>

                <PremiseButton
                  title={t("pricing.premises")}
                  style={{
                    borderRadius: "45px",
                    whiteSpace: "nowrap",
                    fontWeight: 800,
                  }}
                />
                <div className="space-y-4">
                  <p className="text-lg">{e.note}</p>
                  {e?.listConvinient?.map((title, i) => (
                    <p key={i} className="flex gap-2.5 text-lg">
                      <Check1 className="text-[#4B2BE3] mt-1 min-w-[20px] h-[20px]" />
                      <span className="break-words">{t(title)}</span>
                    </p>
                  ))}
                </div>
              </div>
            );
          })}

          <div className="gap-[30px] self-stretch flex flex-col w-[260px] h-auto items-center ">
            <div className=" py-15 px-5 rounded-[20px] shadow-shawdowprice border-2 border-[#9B86FC] h-[444px]">
              <p className="text-[#2B1C50] text-center text-[30px] font-extrabold block mb-2.5">
                {t("pricing.free2")}
              </p>
              <p className="text-[var(--primary)] text-[18px] block mb-2.5">
                {t("pricing.customplan1")}
              </p>
              <p className="text-[#2B1C50] text-[18px] block ">
                {t("pricing.customplan2")}
              </p>

              <Link to={"/contact-us"}>
                <PoppyButton
                  style={{
                    backgroundColor: "#F7941D",
                    color: "#fff",
                    width: "100%",
                    height: "44px",
                    marginTop: "60px",
                  }}
                  title={t("pricing.contact")}
                />
              </Link>
            </div>
            <p className="text-[#2B1C50] text-left text-[18px] font-montserrat flex ml-3">
              {t("pricing.fearures")}
            </p>
          </div>
        </div>
        {/* Description */}
        <div className="mt-20">
          <ul className="text-[#3A505F] space-y-2.5 text-lg py-6">
            <li className="flex gap-2.5">
              <span className="inline-block min-w-2.5 h-2.5 rounded-full bg-[#3A505F] mt-2"></span>
              {/* The CheckID FacialSense Admin app is for employees administration
              and attendance management, available for Windows and Android. Note
              that a paid license is required to use it. */}
              {t(
                "pricing.checkidBioSenseAdminAppIsForEmployeesAdministrationAndAttendanceManagementAvailableForWindowsAndAndroidNoteThatAPaidLicenseIsRequiredToUseIt"
              )}
            </li>
            <li className="flex gap-2.5">
              <span className="block min-w-2.5 h-2.5 rounded-full bg-[#3A505F] mt-2"></span>
              {/* CheckID FacialSense app is a free online tool for personal and
              group attendance tracking. Is available for Windows, Android, iOS
              operating systems. */}
              {t(
                "pricing.checkidBioSenseAppIsAFreeOnlineToolForPersonalAndGroupAttendanceTrackingIsAvailableForWindowsAndroidIOSOperatingSystems"
              )}
            </li>
            <li className="flex gap-2.5">
              <span className="block min-w-2.5 h-2.5 rounded-full bg-[#3A505F] mt-2"></span>
              {/* Prices do not include local import duties or taxes. */}
              {t("pricing.pricesDoNotIncludeLocalImportDutiesOrTaxes")}
            </li>
          </ul>
        </div>
      </div>

      {/* Application */}
      <div className="bg-[#F2F5FE]">
        <div className="md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] mx-auto px-[10px] py-10">
          <div className="flex gap-16 justify-center flex-wrap sm:px-3">
            {license.map((e, index) => (
              //Check Plan
              <div className="space-y-9 flex-1" key={index}>
                <div className="bg-white w-77.5 rounded-[20px] border border-[#9B86FC] p-10 space-y-7.5 mx-auto">
                  <div>
                    <h1 className="text-3xl font-extrabold text-[#002B4E] text-center mb-2">
                      {t(e.name)}
                    </h1>
                    <p className="text-[var(--primary)] text-lg text-center">
                      {t(e.desc)}
                    </p>
                  </div>
                  {e.cost === "pricing.free" && (
                    <p
                      className={`text-[#7F56D9] ${
                        i18n.language === "vi" ? "text-[45px]" : "text-[64px]"
                      } font-bold h-[86px] text-center uppercase`}
                    >
                      {/* FREE */}
                      {t("pricing.free")}
                    </p>
                  )}
                  {e.cost !== "pricing.free" && (
                    <div className="text-[22px] font-bold text-[#002B4E]">
                      <p className="text-center font-extrabold flex items-center justify-center gap-5">
                        <span className="text-[46px] leading-none">$</span>{" "}
                        <span className="text-[#7F56D9] text-[64px] leading-none">
                          {e.cost}
                        </span>
                      </p>
                      <p className="text-nowrap leading-none text-center -mx-10">
                        {/* / license for 1 device */} /{" "}
                        {t("pricing.licenseFor1Divices")}
                      </p>
                    </div>
                  )}
                  <PoppyButton
                    style={{
                      backgroundColor: "#F7941D",
                      color: "#fff",
                      width: "100%",
                      height: "44px",
                    }}
                    title={t(e.buttonText)}
                  />
                </div>
                <div>
                  <p className="text-[var(--primary)] text-lg">{t(e.detail)}</p>
                  <div
                    className={`${
                      e.detail ===
                      "pricing.theCheckidFacialSenseAppIsaFreeOInlineTool" && width > 1025
                        ? "mt-10"
                        : "mt-4"
                    } flex gap-4 max429:flex-wrap`}
                  >
                    {e.listConvinient.map((item, index1) => (
                      <div key={index1} className="space-y-4">
                        {item.map((e, i) => (
                          <div className="flex gap-2.5 mb-2.5" key={i}>
                            <Check1 className="text-[#4B2BE3] mt-1" />
                            <p className="text-[18px]">{t(e)}</p>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Get in touch */}
      <div className="bg-[#151686]">
        <div className="md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] mx-auto px-2 py-10 gap-5 flex justify-between items-center text-white lg:px-6 md:flex-col">
          <div>
            <h1 className="text-[38px] leading-[56px] font-extrabold mb-6 md:text-center">
              {t("pricing.solutions")}
            </h1>
            <ul className="text-lg sm:text-center max-w-[540px] font-normal font-montserrat block ml-10 list-disc mb-5">
              <li className="custom-bullet-list">{t("pricing.solutions1")}</li>
              <li className="custom-bullet-list">{t("pricing.solutions2")}</li>
              <li className="custom-bullet-list">{t("pricing.solutions3")}</li>
            </ul>
            <p className="text-lg sm:text-center max-w-[600px] font-normal font-montserrat block ml-1">
              {t("pricing.solutions4")}
            </p>
          </div>
          <div className="md:mt-5 sm:w-full">
            <Button
              onClick={() => navigate("/contact-us")}
              variant="contained"
              sx={{
                padding: "10px 20px",
                bgcolor: "#F7941D",
                borderRadius: "30px",
                boxShadow: "0px 12px 30px 0px rgba(24, 92, 255, 0.18)",
                width: width < 639 ? "100%" : "auto",
                fontSize: "16px",
                "&:hover": {
                  bgcolor: "rgb(242 170 83)",
                  boxShadow: "0px 12px 30px 0px rgba(24, 92, 255, 0.18)",
                },
                textTransform: "none",
              }}
            >
              {t("pricing.customus")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
